import { render, staticRenderFns } from "./usuariosPerfil.vue?vue&type=template&id=a991d926"
import script from "./usuariosPerfil.vue?vue&type=script&lang=js"
export * from "./usuariosPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports